// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AceEditorController from "./ace_editor_controller"
application.register("ace-editor", AceEditorController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import AutohighlightController from "./autohighlight_controller"
application.register("autohighlight", AutohighlightController)

import BlurContentController from "./blur_content_controller"
application.register("blur-content", BlurContentController)

import ChipsController from "./chips_controller"
application.register("chips", ChipsController)

import ClickProxyController from "./click_proxy_controller"
application.register("click-proxy", ClickProxyController)

import ContentHighlighterController from "./content_highlighter_controller"
application.register("content-highlighter", ContentHighlighterController)

import ContentManagerController from "./content_manager_controller"
application.register("content-manager", ContentManagerController)

import ContentPopoverController from "./content_popover_controller"
application.register("content-popover", ContentPopoverController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import FieldManagerController from "./field_manager_controller"
application.register("field-manager", FieldManagerController)

import FlaggedToggleController from "./flagged_toggle_controller"
application.register("flagged-toggle", FlaggedToggleController)

import LessonEditorController from "./lesson_editor_controller"
application.register("lesson-editor", LessonEditorController)

import LessonEditorLineController from "./lesson_editor_line_controller"
application.register("lesson-editor-line", LessonEditorLineController)

import LessonPlayerController from "./lesson_player_controller"
application.register("lesson-player", LessonPlayerController)

import LinkInvokerController from "./link_invoker_controller"
application.register("link-invoker", LinkInvokerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import RangerController from "./ranger_controller"
application.register("ranger", RangerController)

import SentenceBuilderController from "./sentence_builder_controller"
application.register("sentence-builder", SentenceBuilderController)

import SessionController from "./session_controller"
application.register("session", SessionController)

import SloveneKeyboardController from "./slovene_keyboard_controller"
application.register("slovene-keyboard", SloveneKeyboardController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import YoutubePlayerController from "./youtube_player_controller"
application.register("youtube-player", YoutubePlayerController)
